import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import './styles.scss';

const Tab = ({
  children,
  wrapperClass = '',
  tabsClass = '',
  onTabChange,
  defaultActiveTab,
  contentClass = '',
  tabButtonClass = '',
}) => {
  const getActiveTab = () => {
    return children[defaultActiveTab ? defaultActiveTab : 0]?.props?.label;
  };

  const [activeTab, setActiveTab] = useState(getActiveTab());

  useEffect(() => {
    setActiveTab(getActiveTab());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [children]);

  const handleClick = (label, tabId) => {
    setActiveTab(label);
    onTabChange && onTabChange(tabId);
  };

  return (
    <section className={`tab-wrapper ${wrapperClass}`}>
      <div className={`tabs ${tabsClass}`}>
        {children.map((tabPanel) => {
          const label = tabPanel?.props?.label;
          const tabId = tabPanel?.props?.tabId;
          return (
            <span
              data-isactive={activeTab === label}
              key={label}
              onClick={() => handleClick(label, tabId)}
              className={clsx(
                'tab-button',
                activeTab === label ? 'is-active' : '',
                tabButtonClass
              )}
            >
              {label}
            </span>
          );
        })}
      </div>
      <div className={clsx(['content', contentClass])}>
        {children.map(
          (tabPanel) =>
            tabPanel?.props?.label === activeTab && tabPanel?.props?.children
        )}
      </div>
    </section>
  );
};

Tab.propTypes = {
  children: PropTypes.node.isRequired,
  wrapperClass: PropTypes.string.isRequired,
  tabsClass: PropTypes.string,
  onTabChange: PropTypes.func,
};

export default Tab;
